(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["missingno-sealed-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-mn-sealed-filters]')) return;
    event.preventDefault();
    const selectors = [...form.querySelectorAll('[data-mn-series], [data-mn-language]')];
    const knownTags = new Set(selectors.flatMap((select) => [...select.options].map((option) => option.value)).filter(Boolean));
    const preservedTags = (form.dataset.activeTags || '').split('+').filter((tag) => tag && !knownTags.has(tag));
    const tags = [...new Set([...preservedTags, ...selectors.map((select) => select.value).filter(Boolean)])];
    const url = new URL(form.dataset.collectionUrl + (tags.length ? '/' + tags.join('+') : ''), window.location.origin);
    url.search = window.location.search;
    url.searchParams.delete('page');
    window.location.assign(url.href);
  });
  } catch(e) { console.error(e); }
})();

})();
